import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { requestUpdateUserPassword } from "../../../../../redux/actions/user";
import { sendErrorNotification } from "../../../../universal/notifications/notifications";
import { SolidButton } from "../../../../library/button";
import { Input } from "../../../../library/input";
import { Label } from "../../../../library/label";
import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();

  const updateLoading = useSelector(
    (state) => state.user.updatePassword.loading
  );
  const initialState = { passwordOne: "", passwordTwo: "" };

  const [existingPassword, setExistingPassword] = useState(initialState);
  const [newPassword, setNewPassword] = useState(initialState);

  const clickUpdatePassword = () => {
    if (
      existingPassword.passwordOne !== null &&
      existingPassword.passwordTwo !== null &&
      newPassword.passwordOne !== null &&
      newPassword.passwordTwo !== null
    ) {
      if (existingPassword.passwordOne === existingPassword.passwordTwo) {
        if (
          newPassword.passwordOne.length > 5 &&
          newPassword.passwordTwo.length > 5
        ) {
          if (newPassword.passwordOne === newPassword.passwordTwo) {
            dispatch(
              requestUpdateUserPassword({
                existingPassword: existingPassword.passwordOne,
                newPassword: newPassword.passwordOne,
              })
            );
            setExistingPassword(initialState);
            setNewPassword(initialState);
          } else {
            sendErrorNotification("Det nye passordet er ikke likt.");
          }
        } else {
          sendErrorNotification(
            "Passordet ditt må være lenger enn 5 karakterer."
          );
        }
      } else {
        sendErrorNotification("Eksisterende passord er ikke likt.");
      }
    } else {
      sendErrorNotification("Vennligst fyll inn alle felt.");
    }
  };

  return (
    <div>
      <div className="account-password-tab-content-container">
        <Row className="account-password-row">
          <Col className="account-password-col">
            <Label version={1} weight="bold">
              Nåværende passord
            </Label>
            <Input
              onChange={(e) =>
                setExistingPassword({
                  ...existingPassword,
                  passwordOne: e.target.value,
                })
              }
              value={existingPassword.passwordOne}
              placeholder="Nåværende passord"
              type="password"
            />
          </Col>
          <Col className="account-password-col">
            <Label version={1} weight="bold">
              Nåværende passord igjen
            </Label>
            <Input
              onChange={(e) =>
                setExistingPassword({
                  ...existingPassword,
                  passwordTwo: e.target.value,
                })
              }
              value={existingPassword.passwordTwo}
              placeholder="Nåværende passord igjen"
              type="password"
            />
          </Col>
        </Row>
        <Row className="account-password-row">
          <Col className="account-password-col">
            <Label version={1} weight="bold">
              Nytt passord
            </Label>
            <Input
              onChange={(e) =>
                setNewPassword({ ...newPassword, passwordOne: e.target.value })
              }
              value={newPassword.passwordOne}
              placeholder="Nytt passord"
              type="password"
            />
          </Col>
          <Col className="account-password-col">
            <Label version={1} weight="bold">
              Nytt passord igjen
            </Label>
            <Input
              onChange={(e) =>
                setNewPassword({ ...newPassword, passwordTwo: e.target.value })
              }
              value={newPassword.passwordTwo}
              placeholder="Nytt passord igjen"
              type="password"
            />
          </Col>
        </Row>
      </div>
      <Row className="account-password-bottom-row">
        <Col className="account-password-bottom-col text-right">
          <SolidButton
            onClick={() => clickUpdatePassword()}
            color="blue"
            icon={
              updateLoading && <i className="fas fa-circle-notch fa-spin"></i>
            }
            title={updateLoading ? "Lagrer endringer.." : "Lagre endringer"}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Index;
